/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type KeepVehicleCenteredOnMapButtonVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isSelfDriving: boolean
}

export const KeepVehicleCenteredOnMapButtonVehicleFragmentDoc = gql`
    fragment KeepVehicleCenteredOnMapButtonVehicle on Vehicle {
  id
  isSelfDriving
}
    `
